import React from "react";

export const CircleIcon = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" {...props}>
      <path d="M18 9.5C18 11.376 17.3794 13.1993 16.2348 14.6857C15.0903 16.1722 13.4862 17.2382 11.6725 17.7177C9.85883 18.1972 7.93746 18.0632 6.20787 17.3366C4.47829 16.61 3.03767 15.3316 2.11055 13.7007C1.18342 12.0698 0.821885 10.178 1.08228 8.32017C1.34267 6.46233 2.21037 4.74282 3.55014 3.42965C4.8899 2.11648 6.62646 1.28342 8.48915 1.06032C10.3518 0.83722 12.236 1.23661 13.848 2.19624" stroke="white" strokeWidth="2"/>
    </svg>
  )
}
